// Instrumentação leve da métrica "login → 1ª interação" via GTM dataLayer
// (única infra de analytics disponível hoje). A janela usa o load da home como
// âncora; a correlação com a sessão de login fica no GA4.
let pageLoadedAt: number | null = null
let firstInteractionSent = false

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

export function trackHomeViewed() {
  pageLoadedAt = Date.now()
  firstInteractionSent = false
  push({ event: 'home_viewed' })
}

export function trackFirstInteraction(kind: 'mensagem' | 'clique_feed' | 'aprovacao') {
  if (firstInteractionSent) return

  firstInteractionSent = true
  push({
    event: 'home_first_interaction',
    interaction_kind: kind,
    ms_since_home_load: pageLoadedAt ? Date.now() - pageLoadedAt : null,
  })
}

function push(payload: Record<string, unknown>) {
  if (typeof window === 'undefined' || !Array.isArray(window.dataLayer)) return
  window.dataLayer.push(payload)
}
